/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { UserGroupOptionFragmentDoc } from './UserGroupOptionFragment.hook'

const defaultOptions = {} as const
export type AdminPanelUserManagementUserFormDetailsQueryVariables =
  Types.Exact<{ [key: string]: never }>

export type AdminPanelUserManagementUserFormDetailsQuery = {
  __typename?: 'Query'
  adminPanelUserManagementUserFormDetails: {
    __typename?: 'AdminPanelUserManagementUserFormDetails'
    operatorTenants: Array<string> | null
    customerTenants: Array<string> | null
    ridepoolingServiceTenants: Array<string> | null
    approvers: Array<{
      __typename?: 'BackofficeUserManagementGroup'
      critical: boolean
      gdpr: boolean
      name: string
      displayName: string
      assignedOrganizations: Array<string> | null
    }>
    backofficeGroups: Array<{
      __typename?: 'BackofficeUserManagementGroup'
      critical: boolean
      gdpr: boolean
      name: string
      displayName: string
      assignedOrganizations: Array<string> | null
    }>
    adminPanelGroups: Array<{
      __typename?: 'BackofficeUserManagementGroup'
      critical: boolean
      gdpr: boolean
      name: string
      displayName: string
      assignedOrganizations: Array<string> | null
    }>
    fleets: Array<{
      __typename?: 'BackofficeUserManagementFleet'
      id: string
      name: string
      operatorTenant: string
    }>
    fullServiceAreas: Array<{
      __typename?: 'BackofficeUserManagementServiceArea'
      id: string
      ridepoolingServiceTenant: string
      displayNames: Partial<Record<'de' | 'en' | 'no', string>>
    }>
  }
}

export const AdminPanelUserManagementUserFormDetailsDocument = gql`
    query adminPanelUserManagementUserFormDetails {
  adminPanelUserManagementUserFormDetails {
    approvers {
      ...UserGroupOption
    }
    backofficeGroups {
      ...UserGroupOption
    }
    adminPanelGroups {
      ...UserGroupOption
    }
    operatorTenants
    customerTenants
    ridepoolingServiceTenants
    fleets {
      id
      name
      operatorTenant
    }
    fullServiceAreas {
      id
      ridepoolingServiceTenant
      displayNames
    }
  }
}
    ${UserGroupOptionFragmentDoc}`

/**
 * __useAdminPanelUserManagementUserFormDetailsQuery__
 *
 * To run a query within a React component, call `useAdminPanelUserManagementUserFormDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPanelUserManagementUserFormDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPanelUserManagementUserFormDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminPanelUserManagementUserFormDetailsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AdminPanelUserManagementUserFormDetailsQuery,
    AdminPanelUserManagementUserFormDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdminPanelUserManagementUserFormDetailsQuery,
    AdminPanelUserManagementUserFormDetailsQueryVariables
  >(AdminPanelUserManagementUserFormDetailsDocument, options)
}
export function useAdminPanelUserManagementUserFormDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdminPanelUserManagementUserFormDetailsQuery,
    AdminPanelUserManagementUserFormDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdminPanelUserManagementUserFormDetailsQuery,
    AdminPanelUserManagementUserFormDetailsQueryVariables
  >(AdminPanelUserManagementUserFormDetailsDocument, options)
}
// @ts-ignore
export function useAdminPanelUserManagementUserFormDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdminPanelUserManagementUserFormDetailsQuery,
    AdminPanelUserManagementUserFormDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdminPanelUserManagementUserFormDetailsQuery,
  AdminPanelUserManagementUserFormDetailsQueryVariables
>
export function useAdminPanelUserManagementUserFormDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminPanelUserManagementUserFormDetailsQuery,
        AdminPanelUserManagementUserFormDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdminPanelUserManagementUserFormDetailsQuery | undefined,
  AdminPanelUserManagementUserFormDetailsQueryVariables
>
export function useAdminPanelUserManagementUserFormDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdminPanelUserManagementUserFormDetailsQuery,
        AdminPanelUserManagementUserFormDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdminPanelUserManagementUserFormDetailsQuery,
    AdminPanelUserManagementUserFormDetailsQueryVariables
  >(AdminPanelUserManagementUserFormDetailsDocument, options)
}
export type AdminPanelUserManagementUserFormDetailsQueryHookResult = ReturnType<
  typeof useAdminPanelUserManagementUserFormDetailsQuery
>
export type AdminPanelUserManagementUserFormDetailsLazyQueryHookResult =
  ReturnType<typeof useAdminPanelUserManagementUserFormDetailsLazyQuery>
export type AdminPanelUserManagementUserFormDetailsSuspenseQueryHookResult =
  ReturnType<typeof useAdminPanelUserManagementUserFormDetailsSuspenseQuery>
export type AdminPanelUserManagementUserFormDetailsQueryResult =
  Apollo.QueryResult<
    AdminPanelUserManagementUserFormDetailsQuery,
    AdminPanelUserManagementUserFormDetailsQueryVariables
  >
